import WelcomeProfile from '@/screens/WelcomeProfile';

export default function PrivateWelcomeProfileRoute() {
  return <WelcomeProfile />;
}
